export default [
  // Reclamation subjects list start
  { 
    'tag': 'select',
    'type': 'text',
    'name': 'subject',
    "cf-conditional-category": "category_reclamation",
    'cf-questions': "Choisissez le sujet de la requête ",
    "children": [
        {
          "tag": "option",
          "cf-label": "Monétique",
          "value": "category_monetique",
        }
    ]
  },
  // Reclamation subjects list end
  // Monetique subjects list start
  { 
    'tag': 'select',
    'type': 'text',
    'name': 'objet',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    'cf-questions': "Choisissez l'objet de la requête ",
    "children": [
        {
            "tag": "option",
            "cf-label": "Carte",
            "value": "subject_carte",
        },
        {
            "tag": "option",
            "cf-label": "TPE / Marchand",
            "value": "subject_tpe_marchand",
        },
        {
            "tag": "option",
            "cf-label": "Reclamation financieres",
            "value": "subject_reclamations_financieres",
        },
        {
            "tag": "option",
            "cf-label": "Application",
            "value": "subject_application",
        },
        {
            "tag": "option",
            "cf-label": "Autres",
            "value": "subject_autres",
        },
    ]
  },
  // Monetique subjects list end

  // Subject Carte start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_carte",
    'cf-questions': "Choisissez le motif de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Rejet ATM",
            "value": "reason_rejet_atm", // Charger le formulaire - Carte Magnétique
        },
        {
            "tag": "option",
            "cf-label": "Rejet TPE",
            "value": "reason_rejet_tpe", // Charger le formulaire - Carte Magnétique
        },
        {
            "tag": "option",
            "cf-label": "Rejet en ligne",
            "value": "reason_rejet_en_ligne", // Charger le formulaire - Carte Magnétique
        },
    ]
  },
  // Subject Carte end

  // Subject TPE Marchand start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_tpe_marchand",
    'cf-questions': "Choisissez le motif de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Rejet carte",
            "value": "reason_rejet_carte",
        },
        {
            "tag": "option",
            "cf-label": "Problème de connexion",
            "value": "reason_probleme_de_connexion",
        },
        {
            "tag": "option",
            "cf-label": "Problème de batterie",
            "value": "reason_probleme_de_batterie",
        },
    ]
  },
  // Subject TPE Marchand end

  // Subject application start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_application",
    'cf-questions': "Choisissez le motif de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Netbank",
            "value": "reason_netbank",
        },
        {
          "tag": "option",
          "cf-label": "Pepele",
          "value": "reason_pepele",
      },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_application",
    "cf-conditional-reason": "reason_netbank",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Accès impossible",
            "value": "sub_reason_acces_impossible",
        },
        {
          "tag": "option",
          "cf-label": "Pay secure",
          "value": "sub_reason_pay_secure",
        },
        {
          "tag": "option",
          "cf-label": "Rejet transaction",
          "value": "sub_reason_rejet_transaction",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_application",
    "cf-conditional-reason": "reason_pepele",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
          "tag": "option",
          "cf-label": "Echec de réception notification",
          "value": "sub_reason_echec_reception_notification",
        },
        {
          "tag": "option",
          "cf-label": "Accès impossible",
          "value": "sub_reason_acces_impossible",
        },
        {
          "tag": "option",
          "cf-label": "Rejet transaction",
          "value": "sub_reason_rejet_transaction",
        },
    ]
  },
  
  // Subject application end

  // Reclamation financiere start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_reclamations_financieres",
    'cf-questions': "Choisissez le motif de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Débit à tort",
            "value": "reason_debit_a_tort",
        },
        {
          "tag": "option",
          "cf-label": "Transaction non perçue",
          "value": "reason_transaction_non_percue",
        },
        {
          "tag": "option",
          "cf-label": "Double prélèvement",
          "value": "reason_double_prelevement",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_reclamations_financieres",
    "cf-conditional-reason": "reason_debit_a_tort",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "ATM",
            "value": "sub_reason_atm",
        },
        {
          "tag": "option",
          "cf-label": "TPE",
          "value": "sub_reason_tpe",
        },
        {
          "tag": "option",
          "cf-label": "En ligne",
          "value": "sub_reason_en_ligne",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_reclamations_financieres",
    "cf-conditional-reason": "reason_transaction_non_percue",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
          "tag": "option",
          "cf-label": "ATM",
          "value": "sub_reason_atm",
        },
        {
          "tag": "option",
          "cf-label": "TPE",
          "value": "sub_reason_tpe",
        },
        {
          "tag": "option",
          "cf-label": "En ligne",
          "value": "sub_reason_en_ligne",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_reclamation",
    "cf-conditional-subject": "category_monetique",
    "cf-conditional-objet": "subject_reclamations_financieres",
    "cf-conditional-reason": "reason_double_prelevement",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
          "tag": "option",
          "cf-label": "ATM",
          "value": "sub_reason_atm",
        },
        {
          "tag": "option",
          "cf-label": "TPE",
          "value": "sub_reason_tpe",
        },
        {
          "tag": "option",
          "cf-label": "En ligne",
          "value": "sub_reason_en_ligne",
        },
    ]
  },
  
  // Reclamation financiere end
  
]
